import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { Ripple } from 'primereact/ripple';
import { classNames } from 'primereact/utils';
import './index.css';

interface PropTypes {
    first: number;
    rows: number;
    totalRecords: number;
    onPageChange: (event: PaginatorPageChangeEvent) => void;
}

const PaginatorCustom: React.FC<PropTypes> = ({ first, rows, totalRecords, onPageChange }) => {
    const template = {
        layout:
            'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport',

        FirstPageLink: (options: any) => (
            <button
                type="button"
                className={classNames(options.className, 'border-round')}
                onClick={options.onClick}
                disabled={options.disabled}
            >
                <span title="Về đầu trang">
                    <i className="pi pi-angle-double-left" />
                </span>
                <Ripple />
            </button>
        ),

        PrevPageLink: (options: any) => (
            <button
                type="button"
                className={classNames(options.className, 'border-round')}
                onClick={options.onClick}
                disabled={options.disabled}
            >
                <span title="Về trang trước">
                    <i className="pi pi-angle-left" />
                </span>
                <Ripple />
            </button>
        ),

        NextPageLink: (options: any) => (
            <button
                type="button"
                className={classNames(options.className, 'border-round')}
                onClick={options.onClick}
                disabled={options.disabled}
            >
                <span title="Về trang sau">
                    <i className="pi pi-angle-right" />
                </span>
                <Ripple />
            </button>
        ),

        LastPageLink: (options: any) => (
            <button
                type="button"
                className={classNames(options.className, 'border-round')}
                onClick={options.onClick}
                disabled={options.disabled}
            >
                <span title="Về trang cuối">
                    <i className="pi pi-angle-double-right" />
                </span>
                <Ripple />
            </button>
        ),

        PageLinks: (options: any) => {
            const className = classNames(options.className, { 'p-disabled': true });

            if (
                (options.view.startPage === options.page && options.page !== 0) ||
                (options.view.endPage === options.page && options.page + 1 !== options.totalPages)
            ) {
                return (
                    <span className={className} style={{ userSelect: 'none' }}>
                        ...
                    </span>
                );
            }

            return (
                <button type="button" className={options.className} onClick={options.onClick}>
                    {options.page + 1}
                    <Ripple />
                </button>
            );
        },

        RowsPerPageDropdown: (options: any) => {
            const dropdownOptions = [
                { label: 1, value: 1 },
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
                { label: 100, value: 100 },
                { label: 200, value: 200 },
                { label: 1000, value: 1000 },
                { label: 'All', value: options.totalRecords }
            ];

            return <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />;
        },

        CurrentPageReport: (options: any) => (
            <small className="ml-2">
                Từ {options.first} đến {options.last} trên {options.totalRecords}
            </small>
        )
    };

    return (
        <Paginator
            template={template}
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
            className="justify-content-end"
        />
    );
};

export default React.memo(PaginatorCustom);
